var _style, _g, _path, _path2, _path3, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTechniciansPeople(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C9CACC;}\r\n\t.st1{fill:#452E2F;}\r\n\t.st2{fill:#674546;}\r\n\t.st3{fill:none;stroke:#0D0000;stroke-width:0.75;stroke-miterlimit:10;}\r\n\t.st4{fill:#F29076;}\r\n\t.st5{fill:none;stroke:#949494;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st6{fill:#AC6E61;}\r\n\t.st7{fill:#E07E64;}\r\n\t.st8{fill:#F4F4F4;}\r\n\t.st9{fill:#D6D7D9;}\r\n\t.st10{fill:#649B7A;}\r\n\t.st11{fill:#8ABC9E;}\r\n\t.st12{fill:#474747;}\r\n\t.st13{fill:#75332F;}\r\n\t.st14{fill:#070019;}\r\n\t.st15{fill:#E08067;}\r\n\t.st16{fill:#E88064;}\r\n\t.st17{fill:none;stroke:#0D0000;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st18{fill:#0D0000;}\r\n\t.st19{fill:#DE9919;}\r\n\t.st20{fill:#C48716;}\r\n\t.st21{fill:#F3A81B;}\r\n\t.st22{fill:#74AD8C;}\r\n\t.st23{fill:none;stroke:#D6D7D9;stroke-miterlimit:10;}\r\n\t.st24{fill:#86B79A;}\r\n\t.st25{fill:#E38066;}\r\n\t.st26{fill:#5F9977;}\r\n\t.st27{fill:#2A4435;}\r\n\t.st28{fill:#DE6B5D;}\r\n\t.st29{fill:#CD6356;}\r\n\t.st30{fill:#FFFFFF;}\r\n\t.st31{fill:#9FA0A1;}\r\n\t.st32{fill:#B8B9BA;}\r\n\t.st33{fill:#858687;}\r\n\t.st34{fill:#929394;}\r\n\t.st35{fill:#F5D238;}\r\n\t.st36{fill:#0055A2;}\r\n\t.st37{opacity:0.18;fill:#0D0000;}\r\n\t.st38{fill:#EF941B;}\r\n\t.st39{fill:#FFA726;}\r\n\t.st40{fill:#1B1F23;}\r\n\t.st41{fill:#353836;}\r\n\t.st42{fill:#424242;}\r\n\t.st43{fill:#E8E8E8;}\r\n\t.st44{fill:#333333;}\r\n\t.st45{fill:#FAFAFA;}\r\n\t.st46{fill:#FF8400;}\r\n\t.st47{fill:#E63121;}\r\n\t.st48{fill:#111612;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.3,444.1c1.2-3.3,67.1-6.7,93.1-7.9s87.9,3.7,84.6,11.1c-3.3,7.4-91.1,7-123.8,5.7 C62.5,451.7,39.1,449.9,41.3,444.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236,444.1c1.6-3.3,89.7-6.7,124.5-7.9c34.8-1.1,117.5,3.7,113.2,11.1c-4.4,7.4-121.9,7-165.6,5.7 C264.4,451.7,233.1,449.9,236,444.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284.1,441.7c0,0-1.6,1-1.6,2.1s1.3,2,1.3,2s27.1-0.1,30.8-0.7c3.8-0.6,12-2.1,12-2.1s-0.2,1.6,1.6,1.6 c1.7,0,7.9-0.9,10-1.6s-1.3-4.6-1.3-4.6S323.7,433.4,284.1,441.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M316.6,423c0,0-2.5,5.1-7.5,5.9s-15.8,1.1-18.2,1.1s-8.4,6.8-6.8,11.7c0,0,21.7,1.4,32.1-1 c4.5-1,14.8-3.3,20.8-2.4c0,0,3.7-7.3-1.3-16.3L316.6,423z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 295.1,
    y1: 430,
    x2: 301.2,
    y2: 442.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M306,429.3c0,0,4.1,3.9,8.7,2.7s9.5-5.7,10-9.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M337.8,427.4c0,0-9.2,4.3-8.7,11"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M454.3,441.7c0,0,1.6,1,1.6,2.1s-1.3,2-1.3,2s-27.1-0.1-30.8-0.7c-3.8-0.6-12-2.1-12-2.1s0.2,1.6-1.6,1.6 c-1.7,0-7.9-0.9-10-1.6s1.3-4.6,1.3-4.6S414.7,433.4,454.3,441.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M421.8,423c0,0,2.5,5.1,7.5,5.9s15.8,1.1,18.2,1.1s8.4,6.8,6.8,11.7c0,0-21.7,1.4-32.1-1 c-4.5-1-14.8-3.3-20.8-2.4c0,0-3.7-7.3,1.3-16.3L421.8,423z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 443.3,
    y1: 430,
    x2: 437.2,
    y2: 442.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M432.4,429.3c0,0-4.1,3.9-8.7,2.7s-9.5-5.7-10-9.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M400.6,427.4c0,0,9.2,4.3,8.7,11"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M375.4,178.7L405,268l9.5-5.1c0,0-11.3-81.2-16.8-91.4L375.4,178.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M225.4,174.8l2-4.9c0.8-2.1,2.9-3.4,5.1-3.3l18,0.9l5.1-8.4l-2.2-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M213.3,192.5c0,0,3.4,5.2,5.6,5.2c5,0.1,10-1.8,10-1.8l2.5-10.5c0,0-11.7-4.2-15.1-5L213.3,192.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.9,169.2l-14.6,39.3c0,0,0.5,5.8,7.6,4l17.5-39.3L221.9,169.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M214,178.1c0.8-0.3,5.9,0.1,5.5,3.2c-0.1,1-3,1.5-3,1.5s2.6,0.8,2.5,2.3c0,1.4-2.5,0.9-2.5,0.9 s2.9,0.8,2.8,2.2c-0.1,1.3-3,1.1-3,1.1s3.1,1.1,2.9,2.4c-0.2,1.3-5.8,0.9-5.8,0.9c-1.4-0.8-2.5-2.7-2-4.2c0.1-0.4,0.4-0.8,0.4-1.2 c0.2-1.1-0.5-2.2-0.1-3.3c0.2-0.6,0.6-1.1,0.8-1.6C212.5,181.5,212.3,179,214,178.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M223.7,178.5c-0.2-0.1-3.5-1.8-4.3-1.8s-2.8,3.1-3.1,4s1.6,3.8,2.5,4.1s2-2,0.9-3.9c0,0,3,6.5,5.3,7.2 c2.3,0.6,5.1-0.8,6.3-2.6C231.4,185.5,226.6,179.9,223.7,178.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M222.1,136.1l-2.6,4.1c-1.3,2.1-0.7,4.8,1.4,6.1l25.7,15c2,1.2,4.6,0.6,5.8-1.4l2.4-3.7c1.3-2,0.7-4.8-1.4-6 L228,134.7C226,133.5,223.4,134.1,222.1,136.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M231.4,185.5l47.6,8l9-31.5l21.3,12.1c0,0-14,44.3-17.3,45.7c-7.5,3.3-63.2-23.8-63.2-23.8L231.4,185.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M301.9,119.3c-11,2.7-12,7.6-13.2,12.3c-1.2,4.7-7,49.4-7,49.4l23,7.4C304.7,188.5,309.2,117.5,301.9,119.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M307.8,175.2c0,0-25.4-8.5-26.8-8.7s0,4.4,0,4.4s-4.7,7.5-4.7,9.4s31.5,10.9,31.5,10.9V175.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M398.9,179.2l-19.8,6.4l-1.3,0.4l-0.4,0.1l-1.5,0.5c0,0-0.2-3-0.4-7.7c0-0.1,0-0.2,0-0.3 c-0.1-1.8-0.2-3.8-0.3-6.1c0-0.6,0-1.3-0.1-2c-0.7-16.6-1.2-41.5,1.2-50.1c0.5-1.6,1-2.7,1.7-3c0.2-0.1,0.5-0.1,0.7-0.1 c11,2.7,12,7.6,13.2,12.3c0.1,0.5,0.3,1.5,0.5,2.9l0,0.2c1.1,6.7,3.1,21.4,4.6,32.5c0.3,2.4,0.6,4.7,0.9,6.6c0,0,0,0,0,0 C398.5,176.4,398.9,179.2,398.9,179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M372.8,173.4c0,0,25.4-8.5,26.8-8.7s0,4.4,0,4.4s4.7,7.5,4.7,9.4s-31.5,10.9-31.5,10.9V173.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M375.4,222.9l-1.1-16.3l-69.2-1.2v17.7c-1.6,4.7,4.3,193.4,6.1,198.1s18.9,2.3,24.2,0.8 c5.3-1.6,6.3-154.9,6.3-154.9h4.8l54.4,158.3c0,0,17.3,5,23.1-1.4C427,420.7,377.6,248,375.4,222.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M311,343.4c0,0,2.1-1.2,6.8-1.3c4.7-0.1,6.5,1.7,6.5,1.7s-1,6.5-6.9,6.6S311.2,344.1,311,343.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M384.3,340.7c0,0,1.9-1.6,6.5-2.6s6.7,0.4,6.7,0.4s0.1,6.6-5.8,7.9C385.9,347.6,384.6,341.3,384.3,340.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M333.8,215.2c0,0,3.9,50.8,11.6,51.9l-3-51.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M330.8,104.8c0,0,5-2.6,12.2-3.1s11.6,1.7,11.6,1.7s-4.7,4.1-10.1,4.6S330.8,104.8,330.8,104.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M326.7,67.2c0-0.7,34.4-2.3,34.4-0.7c-0.1,6.2-0.4,15.9-1.5,15.3c-3.8,11.9-22.8,13-30.3,0.6 C328,80.4,327,75.5,326.7,67.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M334.4,91.8v17.7c0,0,7.1,8.2,17.2,0v-17L334.4,91.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M334.4,91.8v9c0,0,4.4,4.1,8.6,4.1s8.6-5,8.6-5v-7.4L334.4,91.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M356.4,65c-1.6-4.7-6.5-5.2-12.9-5.2s-11.3,0.4-12.9,5.2s0.6,19,1.5,22.5c0.9,3.6,6.5,10.9,11.5,10.9 s10.6-7.3,11.5-10.9C356.1,83.9,358,69.7,356.4,65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M344.7,96.9c0-0.4-2.2-0.3-2.1,0.1C342.7,97.3,344.6,97.3,344.7,96.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M354,82.7c0.1-1-4.9-1.1-4.9-0.1S354,84.2,354,82.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M332.7,82.8c0-1,4.9-1,4.9,0.1C337.7,83.9,332.8,84.3,332.7,82.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M340.5,88.6h6.8c0,0-0.8,6.4-3.6,6.4C340.5,94.9,340.5,88.6,340.5,88.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M343.6,77.5c0,0-1.5,6.9-1.4,7.5s2.8,0.2,2.8,0.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M339.9,77.2c0,0.9-0.4,1.7-0.9,1.7s-0.9-0.8-0.9-1.7c0-0.9,0.4-1.7,0.9-1.7S339.9,76.3,339.9,77.2z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M347.3,77.2c0,0.9,0.4,1.7,0.9,1.7s0.9-0.8,0.9-1.7c0-0.9-0.4-1.7-0.9-1.7 C347.7,75.5,347.3,76.3,347.3,77.2z"
  })))))), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M330.9,73.9c0,0-6-2.5-6.3,2.7c-0.4,5.2,2.7,7.3,7.5,5.5L330.9,73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M326.2,77.7c0,0,0.9-1.5,1.9-1.2c0.9,0.3,2.6,2.2,3.2,3.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M355.7,74c0,0,6-2.5,6.3,2.7s-2.7,7.3-7.5,5.5L355.7,74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M361.1,77.7c0,0-0.9-1.5-1.9-1.2s-2.6,2.2-3.2,3.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M330.8,104.8c0,0,16.1,2.7,23.8-1.4l1.4,6.2c0,0-11,8.3-26.2,0.7L330.8,104.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M377.3,175c0,1.1,0,2.1,0,3.1c0,2.2,0,4.4,0.1,6.5c0,0.5,0,1,0,1.5c0,0.7,0,1.3,0,1.9 c0.3,13.2,0.9,23.1,0.5,23.8c-0.9,1.2-2.2,2.3-3.1,2.9c-0.6,0.4-0.9,0.6-0.9,0.6l-8.9,0l-15.1,0.1l-7.4,0l-7.5,0l-1.1,0l-27.4,0.1 c-0.4,0-0.9,0-1.3-0.1c-1.9-0.3-3.6-1.3-4.3-3c0,0,0,0,0,0c0-0.1-0.1-0.3-0.1-0.4c0,0,0-0.1,0-0.1c0,0,0,0,0,0 c0-1.1,0.7-7.1,1.3-15.7c0.1-2.1,0.3-4.3,0.4-6.7c0-0.6,0.1-1.3,0.1-1.9c0.1-3.1,0.2-6.3,0.3-9.7c0-0.7,0-1.3,0-2 c0-0.8,0-1.5,0-2.3v-0.1c0-1,0-2.1,0-3.1c0.1-24-1.1-49.9-1-50.9c0-0.1,0-0.1,0.1-0.2c0.8-1,6.2-3,11.9-4.8 c1.8-0.6,3.7-1.2,5.4-1.7c4.9-1.5,9-2.6,9-2.6s0.4-1.5,1.9-1.7l-0.4,2c0,0,1.1,0.5,2.8,1c4.2,1.3,12.4,3,20-0.1 c1.1-0.4,2.2-1,3.3-1.7l0-0.1l-0.4-1.5c0,0,0.1,0,0.2,0c0.4,0,1.2,0,1.6,0.3c0.4,0.4,0.6,1.2,0.6,1.2s3.3,1.3,7.3,2.8 c1.3,0.5,2.8,1.1,4.1,1.6c1.8,0.7,3.6,1.4,5.1,2c1.6,0.6,2.9,1.2,3.5,1.4c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,1.2,0.2,3.4 c0,8.3-0.9,30.4-1.1,50.8c0,0.4,0,0.8,0,1.1c0,0.5,0,1,0,1.5V175z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M328.3,110c0,0,5.1,5.3,15.6,4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M349.1,114.1c0,0,4.6-1,7.9-4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M302.3,132.6c0,0,2.4,31.9,0,49.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M375.6,132.6c0,0-0.6,32,2.8,49.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M334.1,71.9c-0.1-1.2,7.8-1.6,7.6,0.2C341.4,73.9,334.3,73.5,334.1,71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M354,71.9c0.1-1.2-7.8-1.6-7.6,0.2C346.8,73.9,353.9,73.5,354,71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M322.9,67.2c0,0,0.6-20.4,19.4-20.9c22.2-0.6,20.3,20.9,20.3,20.9H322.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M348.2,46.8c0,0-5.3-1.2-8.8,0.6c-2.7,1.3-6.4,13.9-6.7,19.1h9.5C342.2,66.4,343.9,49.9,348.2,46.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M319.3,67.7c0,0-1.7-9.6,16-10.6c16.2-0.9,24.4,10.1,24.4,10.1L319.3,67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M379.1,174.4c-0.9-0.5-13.2-8.2-12.5-38.9l2.8-21.6l-4.1-1.6l-6,23.2h-36.8l-3.3-22.8l-5.4,1.7l1,21.2 c0,0-6,36-14,39.7c-0.2,19-0.4,35.8-0.1,36.7c1.1,4.3,1.7,8.6,4.3,8.6l70.1-1.8c0,0,6.2-2.9,5.1-8.2 C380,209.6,378.9,193.8,379.1,174.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M329.6,214.4c0,0,1.2-1.5,2.6-1.6c1.5-0.1,5.2,7.6,8.2,7.8s8.4-5.2,9.8-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M321.6,216.1c0,0,1.3,3.7,3,4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M361.1,219.2c0,0,3-1,5.1-6.4c1.3-3.3,2.6,1.8,2.6,1.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 335.8,
    y1: 267.1,
    x2: 357,
    y2: 267.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 278.9,
    y1: 193.5,
    x2: 284.5,
    y2: 195.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 341.7,
    y1: 267.1,
    x2: 335.8,
    y2: 270.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 346.5,
    y1: 267.1,
    x2: 353.5,
    y2: 273.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M315.3,165.1l48.2-0.2c0,0,0.5,32.3,0.2,34.2s-21.5,6.3-25.5,6s-19.3-4.2-20.2-5.3 C317.1,198.5,315.3,165.1,315.3,165.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M395.5,312.8c0,0-2.2-28.3,16.3-32.4s27.5,2.5,32.1,23.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M404.3,281.9l2.1,2.8c0,0,10.6-5.9,20.7-3.2l0.6-3.2C427.6,278.2,414.3,274.2,404.3,281.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M390.9,319.6l11.1,53.2c0,0,34.7,7.9,53.6-10.8l-7.4-51.7L390.9,319.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M386.8,312.3l1.5,10.3c0,0,45.9-2.1,62.8-10.8l-1.2-8.7L386.8,312.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M405.1,268c0,0-0.9,6.8-0.7,8.5c0.2,1.6,2,4,2,4l4-2c0,0,1.6,4.3,3,5.3c1.5,0.9,3.5-0.7,3.5-0.7 s2.5,1,3.6,0.8c1-0.2,1.6-2.1,1.6-2.1s1.4,0.1,1.9,0.1s0.7-7.1-0.2-8.5c-0.9-1.4-9-10.5-9-10.5L405.1,268z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M387.2,314.9c0,0,53.9-6.6,63-9.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M409.1,312.1c0,0,0.1,4.1,0.7,4.3c0.6,0.1,20.8-2.6,21.4-3.2s0-4.2,0-4.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M312.7,220.6c0,0,3.1,24.6-7.9,26.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M366.4,219c0,0,1.3,27.8,12.7,25.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M398.5,417.3c0,0,18.2,4.1,24.3-3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M310.4,413.7c0,0,8,4.1,26.7,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M391.2,150.5c-2.3,1.2-4.4,2.5-6.1,4.1c-0.8,0.7-1.4,1.7-0.3,2.5c0.7,0.5,1.7,0.7,2.6,0.8 c2.3,0.3,4.7,0.7,7,1c0.3,0.4,0.1,0.8-0.4,1.1s-1,0.3-1.6,0.4c-6,1.1-15,5-13.3,7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M290.3,157.4c0,0-1.9-2.2,0-2.6s10.3,7.6,12.1,14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M390.6,211.7c0,0,4.9-3.3,7.8-4.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M158.9,167.4l38.4-28l6.8,7c0,0-46.9,50.5-49.7,50.5c-6.3-0.1-17.1-17.3-17.1-17.3L158.9,167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.8,438.9c0,0-1,0.9,0,3.1c1,2.2,9.6,3.5,17.2,3.1s18.6-2.2,20.1-3.7c1.5-1.6-0.2-3.7-0.2-3.7L63.8,438.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.8,438.9c0.6-2.3,2.7-11.1,12.7-12l3-8.2l18.1,3c0,0,4.6,10.3,3.3,15.8C99.5,443.1,63.1,441.6,63.8,438.9z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.8,441.3c0,0,1.6,0.9,1.7,2s-1.3,2-1.3,2s-27,0.8-30.8,0.3c-3.8-0.4-12.1-1.7-12.1-1.7s0.2,1.6-1.5,1.6 c-1.7,0.1-7.9-0.6-10.1-1.2c-2.2-0.6,1.2-4.7,1.2-4.7S152.9,434.3,192.8,441.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M159.7,423.6c0,0,2.7,5,7.7,5.7s15.8,0.6,18.3,0.5s8.6,6.5,7.2,11.4c0,0-21.7,2.1-32.1,0.1 c-4.5-0.9-14.9-2.8-20.8-1.7c0,0-3.9-7.1,0.7-16.3L159.7,423.6z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 181.5,
    y1: 429.9,
    x2: 175.7,
    y2: 442.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M170.5,429.6c0,0-4,4-8.6,3s-9.7-5.4-10.3-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M138.7,428.8c0,0,9.3,4,9.1,10.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M132,115.1c5.1-0.5,27.1,43,27.1,43s-13.5,17.2-18.7,17.8C135.2,176.5,128.8,115.4,132,115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M160,153.6c0.4,0.9,1.6,5.2,1.6,5.2s3.9,1.8,4,3.8s-22.6,16.8-24.5,16.3c-4-1-3.6-6.4-3.6-8 C137.5,170.5,159,151,160,153.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M51.8,133.9c0,0-23.5,34.4-25.6,40c-3,8.2,33.1,40.1,33.1,40.1l3.1-9l-17.6-27.1L67,147.2L51.8,133.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M76.7,222.9c0,0-6.6,8.9-6.6,33.2c0,8.6,0.4,134.7,0.9,139.9c0.4,5.2,7.5,11.2,7.5,11.2l1,11.5 c0,0,12.8,5.1,19.7,2.6l1.3-10.8c0,0-0.3-2.8,2.4-5.2c2.7-2.4,4.8-102.1,5.2-108.5s1.8-29.9,1.8-29.9 c21.6,128.7,21.9,131.2,21.5,137.1c-0.2,3.8,7,7.7,7,7.7l2.3,11.5c0,0,10.6,3,19.8-0.2v-9.3c0,0,5-4.7,5.8-8S139,219.9,139,219.9 L76.7,222.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M126,261.2c0,0-16.5,7.6-34.6,8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "121.6,272.6 110,267 100.8,274.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M107.7,107.3c0,0,21.4,6.2,24.3,7.9c2.8,1.6,10.9,90.5,12.1,97.4c1.3,7-16,14.3-21.5,15.1s-18.9,1.3-26-1.2 l-19.9-3.4c0,0-7.3-9.2-7.9-12.4s0.3-90.8,1.7-93.4c1.4-2.6,21.1-8.8,21.1-8.8L107.7,107.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M89.1,108.4c0,0-18,2.1-23.7,4.4s-29.1,43-29.1,43c-1.9-1.7,14.5,18.4,21.1,15.5 C59.7,170.1,90.2,130.6,89.1,108.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M103.4,130.9c13.4,78.3,14.3,70.8,6.3,136.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M90.7,216.4c0,0,1-2.9,1.9-3.1s6,12.5,8.5,12.2c2.5-0.4,5.9-4,5.9-4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M130.4,70.3l-30.7-0.2c0,0,6.9-6.6,16.2-6.7C125.1,63.4,130.4,70.3,130.4,70.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M109.5,101.1l0.2,7.6l-2.8,6.7l9,4.7c0,0,2-9.3,1.4-10.1c-0.6-0.8-5-9.4-5-9.4L109.5,101.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "109.6,108.7 109.2,89.5 94,89.8 93.8,107.7 103.4,130.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M98.4,118.7c0,0,5.6,2.7,10.6,0l-5.6,12.2L98.4,118.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M109.2,89.5l0.4,19.2c0,0-14.1,3.3-13.5-15.6L109.2,89.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M119.1,81.9c0,0,7.1-6.2,6.5-11.9c-0.3-3-8.4-9.1-8.4-9.1S94.1,57,92,60.2c-1.5-0.4-3.5-0.7-4.7,1.7 c-0.8,1.5-2.4,29.9,8,29.6L119.1,81.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M116.3,80.9c0,0,5.8-3,6.6,2.2c0.8,5.3-2.2,7.7-7.1,6.2L116.3,80.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M120.6,79.1c0.3,5.9-0.3,22-10.9,23.5C96.3,104.5,93.2,84,93,82.5c-0.1-0.5-0.1-1-0.2-1.5 c-0.6-4.7-0.3-12.2,9.2-15.6c6.8-2.4,16.5,2.6,18.4,10.1C120.2,75.6,120.4,77,120.6,79.1z"
  })))))), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M118.4,62.9c0,0,5.6,10.7,2.1,11.7s-25.7-8.9-25.7-8.9S105.8,54.6,118.4,62.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M94.2,82.8c0,0-6.2-2-6.2,3.3s3.4,7.2,8,4.9L94.2,82.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M89.1,87.1c0,0,0.8-1.6,1.8-1.4c0.9,0.2,2.8,2,3.6,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M96,64.7c0,0,6.4,4.2,5.5,8.4C101.1,75.4,96,79,96,79s-0.5,5-1.9,5.1s-2.5-3.4-3-7C90.6,73.4,86,67,96,64.7z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M113.1,84.1c0.1,0.8,0.5,1.5,1,1.5s0.8-0.8,0.7-1.6c-0.1-0.8-0.5-1.5-1-1.5 C113.4,82.6,113,83.3,113.1,84.1z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M106.5,84.7c0.1,0.8-0.2,1.6-0.7,1.6s-0.9-0.6-1-1.5s0.2-1.6,0.7-1.6S106.5,83.8,106.5,84.7z"
  })))))), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M118,78.9c0-1.1-7.2-0.9-6.8,0.7C111.6,81.2,117.9,80.3,118,78.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M100,80.4c-0.2-1.1,6.9-2.1,6.8-0.4C106.7,81.6,100.3,81.8,100,80.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M110.2,99.7c0-0.4-2.2-0.2-2.1,0.2C108.3,100.2,110.2,100.2,110.2,99.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M111.8,96.4c-1.8,0.6-3.7,0.6-5.5,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M119.7,89.6c0-1-4.9-0.8-4.9,0.3C114.8,90.9,119.7,91.1,119.7,89.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M98.4,91c-0.1-1,4.8-1.3,4.9-0.3C103.4,91.8,98.6,92.4,98.4,91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M110,84c0,0-0.7,5.3,2.5,5.7c0,0,0.2,1.7-2.5,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M93.9,100.2c0,0-6.3,1.9-6.9,2.5s-1.8,7.5-2.1,8.3s5.9,10,5.9,10l7.6-5.3l-4.6-8L93.9,100.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "98.4,115.7 103.4,130.9 93.8,118.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "107.7,115.7 103.4,130.9 112.4,118.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M122.9,63.2c0,0-1.4-7-2.9-8.8c-1.4-1.8-9.8-3.7-13.5-3.6c-3.4,0.1-18.4,5.9-19.5,9.9 c-0.7,2.5,0,12.4-0.3,11l15.3-1.6C102,70.1,109.7,62.1,122.9,63.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M99.7,70.2c0,0-1.7-7.7-1.6-8.7s4.5-10.6,8.4-10.7c3.4-0.1,7.9,3.6,9.7,5.4c1,1,1.1,8.1,1.1,8.1L99.7,70.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M130.4,70.3c0,0,3.5-6.8-8.1-9.8c-5.7-1.5-20,1.6-23.3,9.7c0,0,3.3,0.7,4.7-0.1 C109.3,67.2,119.6,62.1,130.4,70.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.7,222.9c0,0,42.2,6.5,62.3-3l1.1,12.5c0,0-40.1,14.5-67.3,0C72.8,232.4,73.3,226.3,76.7,222.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M87.8,214.9l-4.5,14.4l0.3,1.8l-2,0.8l-0.7,3.3l8,2.6l1.4-2.9l-0.9-1.5l1.9-1.6l5.2-14.2 C96.6,217.6,94.2,214.3,87.8,214.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M87.4,216.4L87.4,216.4c1.2,0.2,2,1.4,1.7,2.6l-2.4,7.8c-0.3,1.1-1.5,1.7-2.5,1.3l-0.3-0.1L87.4,216.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M95.9,219.4L95.9,219.4c-1.2-0.4-2.5,0.3-2.9,1.4l-2.4,6.7c-0.4,1.1,0.1,2.3,1.1,2.8l0.2,0.1L95.9,219.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M90.4,218.8l-3.1,9c-0.2,0.6,0.1,1.3,0.8,1.5l0,0c0.6,0.2,1.2-0.1,1.5-0.7l3.1-9c0.2-0.6-0.1-1.3-0.8-1.5 l0,0C91.2,217.9,90.6,218.2,90.4,218.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "81.3,233.5 89.8,236.3 89.5,236.9 81.2,234.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M86.2,217l-1.2,3.4c-0.2,0.5-0.8,0.8-1.3,0.6l-2.4-0.8c-0.5-0.2-0.8-0.8-0.6-1.3l1.2-3.4 c-2.1,0.3-4,1.9-4.4,4.2s0.8,4.6,2.9,5.6c2.9,1.4,6.2-0.1,7.2-3C88.1,220.4,87.5,218.4,86.2,217z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5,
    y: 229.1,
    transform: "matrix(0.3237 -0.9462 0.9462 0.3237 -165.3487 230.9903)",
    className: "st9",
    width: 16.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.7,235.2c0,0-0.7,2.4-1.6,5.5c-1.3,4.6-3.2,10.7-3.8,12.2c-1,2.3-17.4,7.1-18.5,4.4 c-0.7-1.8-0.2-15.4,1.5-21.8c0.8-2.8,1.5-5.1,2-6L93.7,235.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.7,235.2c0,0-0.7,2.4-1.6,5.5c-6.2-0.6-15.3-3.4-20.7-5.2c0.8-2.8,1.5-5.1,2-6L93.7,235.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "127.3,223.7 130.8,236.9 133.9,235.2 130.6,222.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M120.5,237.2l-1.1-9.2l-0.4-3.5l-0.2-1.8l-4.4,0.2l-9.6,0.5l-4.8,0.2V242l12.8-0.9l8.1-0.5L120.5,237.2z  M102.8,225.9l11.5-0.4l1.5,0l0.2,2.8l0.5,9.2l-3.3,0.2l-10.4,0.7V225.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M119.2,221.5c2.4-2.9,2.8,2.8,6.1,2.2s5.4-4.4,5.4-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65.1,201.6c0,0,2.1-9.7,3.3-10c1.2-0.3,1.2,10.8,1.2,10.8L65.1,201.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M66.7,216.8c-2,0.9-7.3-2.7-7.3-2.7l3.1-9c0,0,4.8-6.5,5.8-7.1s10.3,1.2,10.9,2.3c0.7,1.1-8.1,1.6-8.1,1.6 s9.5,3.2,9.1,4.6s-8.3-0.6-8.3-0.6s4.6,3.2,4,4.1c-0.6,0.9-5.7-1.5-5.7-1.5S71.1,214.8,66.7,216.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 44.9,
    y1: 177.9,
    x2: 40.8,
    y2: 173.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M69.1,156.2c0,0,3.6-10.6,4.6-36.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M82.1,138.1c0,0-7.5,12.7-12.3,15.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M54.2,126.4c2.6,0.1,9.4,6.3,9.8,7.5s-2.9,3.4-3.5,4.3s-8.5,0.4-9.3,0s-2.9-3.4-2.7-4.3 C48.9,132.5,53.6,126.4,54.2,126.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M33.4,152.8c-0.3,1-1.5,5.2-1.5,5.2s-3.9,1.9-3.9,3.9c0,1.9,23.4,15,25.3,14.5c3.9-1.1,6.4-5.2,6.4-6.9 C59.7,169,34.3,150.1,33.4,152.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 129.4,
    y1: 168.9,
    x2: 89.8,
    y2: 202.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 125.9,
    y1: 187.4,
    x2: 114.9,
    y2: 202.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M134.2,124.8c0,0,7,40.5,6.2,51.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M143,141.1c0.3,7.1-1,14.3-3.8,20.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M213.1,141.4c0,0-0.9,6.1-3,7.1c-4.5,2.1-9.8,2.4-9.8,2.4l-6.6-8.5c0,0,9-8.6,11.7-10.8L213.1,141.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M220.3,153.3c-0.6-0.9-3.8-5.8-7.3-11.2c-0.1-0.2-0.2-0.3-0.3-0.5c-0.8-1.2-1.5-2.5-2.3-3.7 c-2-3.2-3.9-6.4-5.2-8.8c-0.8-1.5-1.5-2.8-1.7-3.6c-1.7-4.9-0.9-13-0.9-13l-2.4,0.5l-6.2,1.2l-4.7,1l-2.7-1.8l-1.6-9.1 c0,0-1.8,0.8-2.6,2.7s-2.7,6.7-1.1,10.5c1.6,3.8,12.5,9.4,14.7,10.7c0.5,0.3,1.4,1.7,2.7,3.8c0.7,1.1,1.4,2.4,2.1,3.8 c0.4,0.7,0.8,1.4,1.1,2.1c2,3.7,4.1,8,5.9,11.5c1.8,3.6,3.2,6.6,3.8,7.7c1.8,3.6,4.9,4.1,7.1,2.9 C220.8,158.8,221.7,155.3,220.3,153.3z M217.8,158c-1.2,0.8-2.9,0.4-3.7-0.8c-0.8-1.2-0.4-2.9,0.8-3.7c1.2-0.8,2.9-0.4,3.7,0.8 C219.4,155.5,219.1,157.2,217.8,158z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M197.5,106.5c0.5,1.8,2.6,6.5,2.6,6.5l-5.4,1.1l-2.2,0.4l-1.9-10.7c0,0,1.1-0.1,2.4,0 C194.8,104,196.9,104.6,197.5,106.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M200,129.9l11.3,21.1c0.4,0.8,1.4,1.1,2.2,0.6l0.7-0.4c0.7-0.4,1-1.4,0.6-2.1l-12-20.6 c-0.4-0.7-1.4-1-2.1-0.6l0,0C199.9,128.2,199.7,129.2,200,129.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M193,103.8l1.7,10.2l-2.2,0.4l-1.9-10.7C190.6,103.8,191.7,103.6,193,103.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "192.5,116.6 193.3,120.8 200.1,119.4 199.2,115.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "193.6,117.1 194.4,119.9 195.9,119.7 195.2,116.7  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M206.5,128.5c-0.9,0.1-5.3,2.5-3.6,5.2c0.5,0.8,3.3,0.1,3.3,0.1s-2,1.8-1.4,3.1s2.6-0.2,2.6-0.2 s-2.3,1.9-1.6,3.1c0.6,1.1,3.2-0.2,3.2-0.2s-2.4,2.3-1.6,3.4c0.8,1.1,5.7-1.6,5.7-1.6c0.9-1.3,1.2-3.5,0.1-4.7 c-0.3-0.3-0.7-0.6-0.9-0.9c-0.6-0.9-0.5-2.2-1.2-3.1c-0.4-0.5-1-0.7-1.4-1.2C209.2,131,208.5,128.7,206.5,128.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M197.8,132.9c0.2-0.2,2.4-3,3.1-3.4c0.7-0.4,3.9,1.6,4.4,2.3c0.6,0.7,0.1,4.1-0.6,4.8s-2.7-1-2.5-3.2 c0,0-0.1,7.2-1.9,8.7c-1.8,1.5-4.9,1.3-6.8,0.3C193.7,142.4,195.7,135.3,197.8,132.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.5,426.9c0,0,15-0.9,19.7,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M159.5,413.5c0,0-4.9,2-13.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.5,406.9c0,0,5.8,4.5,17.9,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M84.8,327.6c0,0,2.1-1.2,6.8-1.3c4.7-0.1,6.5,1.7,6.5,1.7s-1,6.5-6.9,6.6C85.3,334.7,85,328.2,84.8,327.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M135.5,326.9c0,0,1.9-1.6,6.5-2.6s6.7,0.4,6.7,0.4s0.1,6.6-5.8,7.9C137.1,333.8,135.8,327.5,135.5,326.9z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M368.6,63.9l1,7.1l0.4,6.6c0,0-0.7,0.1-1.5-0.2c0,0,0-10.1-0.8-13.5C367.8,63.9,368.4,63.8,368.6,63.9 L368.6,63.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M366.7,64.2c0,0,0.6-0.3,1-0.3c0,0,0.5,2.4,0.7,7.1c0,0-0.3,0-1,0.2C367.5,71.2,367.4,66.7,366.7,64.2 L366.7,64.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M392.5,132.9c-2.8-6.3-9.2-10.2-14-11.8c-0.8-0.3-1.5-0.5-2.2-0.6c-0.5-0.1-1-0.2-1.5-0.2 c-1.3-0.1-2.2-0.3-2.8-0.6c-1.5-0.7-1.1-1.6-1.1-1.6l1-1.9l2.6-0.1c1.6,0.6,2.9,1.2,3.5,1.4c0.2-0.1,0.5-0.1,0.7-0.1 c11,2.7,12,7.6,13.2,12.3c0.1,0.5,0.3,1.5,0.5,2.9L392.5,132.9z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M380.6,109.8c0.1-0.5-0.3-1-0.9-1c-0.4,0-0.8,0.3-0.9,0.8l-0.7,3.7c0,0,0,0,0,0c-0.3,1.4-1.7,2.3-3.1,2 l-0.6-0.1c-0.9-0.2-1.9,0.1-2.6,0.7c-0.5,0.5-0.9,1.2-1,2c-0.1,0.5,0.2,0.9,0.7,1c0,0,0,0,0,0c0.5,0.1,0.9-0.2,1-0.7 c0.1-0.5,0.2-0.8,0.5-1c0.2-0.2,0.4-0.2,0.6-0.3c-0.3,0.4-0.4,0.9-0.5,1.5c-0.1,0.5,0.2,0.9,0.7,1c0,0,0,0,0,0 c0.5,0.1,0.9-0.2,1-0.7c0.1-0.8,0.5-1.2,1.1-1.4l0,0c-0.3,0.4-0.5,0.9-0.6,1.5c-0.1,0.5,0.2,0.9,0.7,1c0,0,0,0,0,0 c0.5,0.1,0.9-0.2,1-0.7c0.1-0.5,0.2-0.8,0.5-1c0,0,0,0,0.1-0.1c1.4-1.1,1.7-2.7,2-4c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0.1-0.3 L380.6,109.8L380.6,109.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M386.2,110.9c0.1-0.5-0.3-1-0.9-1c-0.4,0-0.8,0.3-0.9,0.8l-0.7,3.7c0,0,0,0,0,0c-0.3,1.4-1.7,2.3-3.1,2 l-0.6-0.1c-0.9-0.2-1.9,0.1-2.6,0.7c-0.5,0.5-0.9,1.2-1,2c-0.1,0.5,0.2,0.9,0.7,1c0,0,0,0,0,0c0.5,0.1,0.9-0.2,1-0.7 c0.1-0.5,0.2-0.8,0.5-1c0.2-0.2,0.4-0.2,0.6-0.3c-0.3,0.4-0.4,0.9-0.5,1.5c-0.1,0.5,0.2,0.9,0.7,1c0,0,0,0,0,0 c0.5,0.1,0.9-0.2,1-0.7c0.1-0.8,0.5-1.2,1.1-1.4l0,0c-0.3,0.4-0.5,0.9-0.6,1.5c-0.1,0.5,0.2,0.9,0.7,1c0,0,0,0,0,0 c0.5,0.1,0.9-0.2,1-0.7c0.1-0.5,0.2-0.8,0.5-1c0,0,0,0,0.1-0.1c1.4-1.1,1.7-2.7,2-4c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0.1-0.3 L386.2,110.9L386.2,110.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M395.4,98.9l-3.6,19.7c0,0-2.8-1-6.4-3.1c-6.7-4-15.9-11.9-14.1-24.7l1.4-7.4c0.3-1.5-0.1-3-1.1-4.2 c-0.1-0.1-0.2-0.3-0.3-0.4c-0.3-0.3-0.7-0.6-1-0.9c-0.6-0.4-1.1-0.8-1.5-1.3l0,0c-1.8-1.9-2.8-4.6-2.5-7.3c0.1-0.7,0.2-1.4,0.4-2.1 c0.4-1.2,1-2.3,1.8-3.2c1.8-2.2,4.5-3.5,7.4-3.3c3.8,0.2,7.7,2.3,10.9,5.7c5.1,5.4,8.9,14.1,9.1,24.3c0,1.2,0,2.3,0,3.5 c-0.1,1.4-0.2,2.8-0.4,4.2C395.4,98.5,395.4,98.7,395.4,98.9L395.4,98.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M395.5,98.3l-6.1-13.5c-0.3-2.7-1-5.1-1.9-7.3c-2.7-6.5-7.2-10.8-7.6-11.2c0,0,0,0,0,0 c-3.6-3.6-11.4-2.5-11.4-2.5c1.8-2.2,4.5-3.5,7.4-3.3c3.2,0.2,6.4,1.6,9.2,4.1C392.3,70.8,397.5,83.6,395.5,98.3L395.5,98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M371.6,79.1c-0.4-0.5-0.8-0.9-1.4-1.3c-0.4-0.3-0.9-0.7-1.2-1c-0.1-0.1-0.2-0.2-0.3-0.3l0,0 c-0.9-3.2-2-8.5-0.3-12.6c0,0,9.7-1.4,12.5,3.9c0.3,0.5,0.5,1.1,0.6,1.7C381.5,69.5,381.3,78.5,371.6,79.1L371.6,79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M387.5,77.5c-2.7-6.5-7.2-10.8-7.6-11.2c0,0,0,0,0,0c-3.5-3.5-11.1-2.5-11.4-2.5l0,0l0,0c0,0,0,0,0,0 c1.8-2.2,4.5-3.5,7.4-3.3c3.2,0.2,6.4,1.6,9.2,4.1C386.9,69,387.4,74.3,387.5,77.5L387.5,77.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M372.4,84.8l0.3-1.5c0-0.2,0.1-0.4,0.1-0.7c0.1-1.3-0.4-2.5-1.1-3.5c-0.1-0.1-0.2-0.3-0.3-0.4 c3-0.9,9-3.4,10.2-9.2c0.8-3.9,0.8-3.9,0,0C381.6,69.8,385.9,80.6,372.4,84.8L372.4,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M376.4,68c-0.2,1-1.1,1.6-2,1.4s-1.6-1.1-1.4-2c0.2-1,1.1-1.6,2-1.4C376,66.2,376.6,67.1,376.4,68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M395.4,98.9l-3.6,19.7c0,0-2.8-1-6.4-3.1c-0.8-1.9-2-3.9-3.7-5.8c-8-9.1-4.1-19.3-4.1-19.3l18.3,3.8 c-0.1,1.4-0.2,2.8-0.4,4.2C395.4,98.5,395.4,98.7,395.4,98.9L395.4,98.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M385,64.6c-9.7-7-16.4-0.9-16.6-0.7l0,0l0,0c1.8-2.2,4.5-3.5,7.4-3.3C379,60.7,382.2,62.2,385,64.6L385,64.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M395.9,90.6c-2.8-14.5-9.1-24.3-9.1-24.3C391.9,71.6,395.6,80.3,395.9,90.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M372.4,84.8l0.3-1.5c0-0.2,0.1-0.4,0.1-0.7c3.1-0.8,9.8-3.6,8.8-13.2C381.6,69.8,385.9,80.6,372.4,84.8 L372.4,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M371.6,79.1c-0.4-0.5-0.8-0.9-1.4-1.3c-0.4-0.3-0.9-0.7-1.2-1l0.8-1.2c0,0,9.8-0.6,11.1-7.8 c0.3,0.5,0.5,1.1,0.6,1.7C381.5,69.5,381.3,78.5,371.6,79.1L371.6,79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M369.5,70.9c-4.5-0.1-7,5.6-7,5.6s0,0,0,0c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.9-1.6-3.7-0.3-7.2 c0.7-1.9,2-3.6,3.9-4.5c0.7-0.4,1.6-0.6,2.6-0.6l0.1,0.7L369.5,70.9L369.5,70.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M369.9,77.6c-4.1,0-5.5-4-5.5-4c0.2-0.4,0.5-0.7,0.8-1c1.9-1.9,4.3-1.6,4.3-1.6l0.3,4.6L369.9,77.6 L369.9,77.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M362.5,76.5L362.5,76.5c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.9-1.6-3.7-0.3-7.2c0.7-1.9,2-3.6,3.9-4.5 c0.7-0.4,1.6-0.6,2.6-0.6l0.1,0.7C360.7,65.4,362.4,76.2,362.5,76.5L362.5,76.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M369.9,77.6c-4.1,0-5.5-4-5.5-4c0.2-0.4,0.5-0.7,0.8-1c0.5,1.2,1.7,2.7,4.6,3L369.9,77.6L369.9,77.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M394.7,118.8c0,0-12.9-8-16.5-18.5c-1-2.9-1.3-6.1-0.4-9.3c0.3-0.9,0.5-1.8,0.8-2.6c0.1-0.2,0.1-0.4,0.2-0.6 c2.9-8,14.4-7.3,16.4,1c0.4,1.8,0.8,3.7,1.1,5.6c0.5,3.4,0.8,7,0.8,10.7C396.9,109.6,396.3,114.2,394.7,118.8L394.7,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M380.7,88.8c0.3-1.1,0.6-2.2,1-3.1c0.4-1.1,0.9-2,1.6-2.8c-2,0.9-3.6,2.5-4.5,4.9c-0.4,1-0.7,2-1,3.1 c-4.2,14.8,16.9,27.8,16.9,27.8c0.4-1.2,0.7-2.3,1-3.5C390.6,111.7,377.3,100.8,380.7,88.8L380.7,88.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M399.3,117.5c0,0-14.9-7.1-20.1-17.1c-1.4-2.8-2.1-5.9-1.5-9.1c0.2-0.9,0.4-1.7,0.6-2.5 c0-0.2,0.1-0.4,0.2-0.6c2.3-8,14.9-7.9,18,0c0.7,1.7,1.3,3.5,1.8,5.4c1,3.2,1.7,6.7,2,10.3C400.8,108.4,400.5,113,399.3,117.5 L399.3,117.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M380.8,89.1c0.2-1.1,0.5-2.1,0.7-3.1c0.3-1.1,0.8-2,1.4-2.8c-2.1,0.9-3.7,2.6-4.4,5c-0.3,1-0.5,2-0.7,3.1 c-2.9,14.6,21.5,26.2,21.5,26.2c0.3-1.1,0.5-2.3,0.7-3.4C394.1,110.8,378.4,100.9,380.8,89.1L380.8,89.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M403.5,115.5c0,0-16.4-6.6-22.5-16.2c-1.7-2.7-2.6-5.7-2.2-8.8c0.1-0.9,0.3-1.7,0.5-2.5 c0-0.2,0.1-0.4,0.1-0.6c1.8-7.8,15.2-8,19.1-0.3c0.8,1.6,1.6,3.4,2.3,5.2c1.2,3.1,2.3,6.5,2.9,10 C404.4,106.7,404.5,111.1,403.5,115.5L403.5,115.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M381.8,88.2c0.2-1.1,0.4-2.1,0.6-3c0.2-1,0.7-2,1.3-2.7c-2.1,1-3.7,2.6-4.3,5c-0.2,0.9-0.4,2-0.6,3 c-2.1,14.3,24.7,25,24.7,25c0.2-1.1,0.4-2.2,0.5-3.4C397.5,109.1,380.1,99.8,381.8,88.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechniciansPeople);
export default __webpack_public_path__ + "static/media/technicians-people.7db8ed1e7938b97cb560c60d2f84f551.svg";
export { ForwardRef as ReactComponent };